import { gql } from "@apollo/client";

export const MARK_INVOICE_UPLOAD_DOCUMENT_AS_MANUALLY_HANDLED = gql`
  mutation markInvoiceUploadDocumentAsManuallyHandled(
    $input: MarkUploadDocumentAsManuallyHandledInput!
  ) {
    documentHandler {
      markInvoiceUploadDocumentAsManuallyHandled(input: $input) {
        success
      }
    }
  }
`;
